import React, { useMemo } from 'react';

import { useParams } from 'react-router-dom';
import { CTitle, WTitle } from '../../components/Widget';
import ArrowImg from '../../../../../../assets/2025/arrow.gif';
import { useUpdateComponentState } from '../../../hooks';

interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );
  const [state, setState] = React.useState({
    play: 1,
    isPlayed: false,
  });

  const updateComponentState = useUpdateComponentState();
  const startPlay = (next = 1) => {
    if (state.isPlayed) {
      return;
    }
    next += 1;
    setState({ play: next, isPlayed: true });
    updateComponentState(p_course, p_topic, ID, '2025-topic1600-section1-1');
    if (next <= 6) {
      setTimeout(() => startPlay(next), 1000);
    }
  };
  return (
    <>
      <div className="topic-section-1">
        <WTitle title={paragraphsSettings?.title}></WTitle>
        <div className="introduction-container">
          <CTitle title={paragraphsSettings?.l1}></CTitle>
          <div className="content-container">
            <div className="side-back">
              <div
                className="question"
                dangerouslySetInnerHTML={{
                  __html: paragraphsSettings?.l2,
                }}
              />
            </div>
            <div className="top">
              <div className="content">
                <p>{paragraphsSettings?.l3}</p>
                <p>{paragraphsSettings?.l4}</p>
              </div>
            </div>

            <div className="bottom">
              <p
                dangerouslySetInnerHTML={{
                  __html: paragraphsSettings?.l5,
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: paragraphsSettings?.l6,
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: paragraphsSettings?.l7,
                }}
              />
              <div className="source-box">
                <p>{paragraphsSettings?.l7a}</p>
                <p>
                  <a
                    href={paragraphsSettings?.l7b_1}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {paragraphsSettings?.l7b}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div id="2025-topic1600-section1-1" className="attentions-container">
          <CTitle title={paragraphsSettings?.l8}></CTitle>
          <div className="content" onClick={() => startPlay()}>
            <div className="tip">{paragraphsSettings?.l9}</div>
            <div
              className="arrow"
              style={{ display: state.isPlayed ? 'none' : 'block' }}
            >
              <img src={ArrowImg} alt="" />
            </div>
            <div className="item-wrap">
              {paragraphsSettings?.l10?.map(
                (item: { no: string; desc: string }, index: number) => (
                  <div
                    key={item.no}
                    className={`attention-item ${
                      state.play > index + 1 ? 'fade-in' : ''
                    }`}
                  >
                    <div className="item-no">{item.no}</div>
                    <div className="item-desc">{item.desc}</div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
        <div className="background-pic"></div>
      </div>
    </>
  );
};

export default Section1;
